<template>
  <div class="employeeLIstVue">
    <!-- Main Body Content area -->
    <div class="o-main-content-area">
        <!-- Heading Section -->


        <div class="row c-responsive-fixwidth">
            <div class="col-md-3">
                <h1 class="h1">Employees</h1>
            </div>
            <div class="col-md-9 text-right">
                <ul class="o-filter-area">

                    <li class="o-search-field">
                        <div class="input-group stylish-input-group">
                            <input type="text" class="form-control" placeholder="Search" v-model="search_query" v-on:keyup="updateValue">
                            <span class="input-group-addon">
                                <button type="submit">
                                <span class=""><i class="fa fa-search" aria-hidden="true"></i></span>
                            </button>
                            </span>
                        </div>

                    </li>
                    <li><a href="javascript: void(0)" @click="goToMerge()" class="c-common-btn c-common-btn--inverse-icon-green"><i class="fa fa-plus" aria-hidden="true"></i> Merge Employee</a></li>

                    <!-- <li><a href="javascript: void(0)" class="c-common-btn c-common-btn--inverse-icon-red"><i class="fa fa-trash-o" aria-hidden="true"></i> Delete Employee</a></li> -->

                </ul>

            </div>
        </div>



        <!-- /Heading Section -->
    </div>

    <div class="o-ndividualArea c-responsive-fixwidth">
        <div class="o-ndividualTable">

            <div class="c-common-space o-individual-calls">
                <div class="col-md-12 o-no-padding">
                    <form class="form-inline">
                        <!-- <div class="form-group o-margin-right-10">
                        <label for="exampleInputEmail3" class="common-label-text">Status Lavel</label>
                            <div class="o-cutsomSelect o-display-inline">
                                <select class="form-control fix-width-input">
                                    <option>Group A</option>
                                    <option value="all">All</option>
                                </select>
                            </div>
                        </div> -->
                    <div class="form-group ">
                        <label for="exampleInputEmail3" class="common-label-text">Sort By</label>
                        <div class="o-cutsomSelect o-display-inline">
                            <select v-model="selectedShortType" @change="getAllEmployee()" class="form-control fix-width-input">
                                <option value="fname_asc">FirstLast (Employee name)</option>
                                <option value="fname_desc">LastFirst (Employee name)</option>
                                <option value="seniority">Seniority </option>
                                <option value="email">Email ID</option>      
                            </select>
                        </div>
                    </div>
                        <!-- <button type="submit" class="c-common-btn c-common-btn--green">Go</button> -->
                    </form>
                </div>
            </div>

            <div class="o-skills-listing">
                <div class="row">
                    <div class="col col-sm-12">
                       <div class="o-scheduleTable--daily">
                          <div v-infinite-scroll="loadMore" infinite-scroll-disabled="busy" infinite-scroll-distance="10" v-loading="loading">
                                <div v-for="(employee,empIndex) in employees" :key="empIndex" class="o-calls-table c-common-gradient c-common-box-shadow c-radius3 c-margin-bottom-10 employees-list-table-align employees-list-table">
                                        <div class="calls-table-row">

                                            <div class="calls-table-cell">
                                                <div class="o-right-side-padding5">
                                                    <div class="calls-table-cell-inner-table o-modal-trigger" data-toggle="modal" data-target="#employeeSummaryModal">
                                                        <div class="o-accordion-subtext user-icon o-list-user-img">
                                                            <div class="o-post-logged o-post-logged--table-user">
                                                                <div class="o-user-profile-img o-header-profile-pic">
                                                                    <div v-if="employee.employable">
                                                                        <img v-if="employee.employable.image && employee.employable.image != '' &&employee.employable.image != 'NULL'" :src="(employee.employable.image)"  id='img-upload'/>
                                                                        <img v-if="!employee.employable.image && employee.employable.image == '' ||employee.employable.image == 'NULL'" src="static/assets/images/user1.png" id='img-upload' />
                                                                    </div> 
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="o-accordion-subtext o-rowtable-text">
                                                            <span>Name</span>
                                                            
                                                            <div>{{employee.employable ? ((selectedShortType=='fname_asc')?employee.employable.first_name+" "+employee.employable.last_name:(selectedShortType=='fname_desc'?employee.employable.last_name+", "+employee.employable.first_name:employee.employable.first_name+" "+employee.employable.last_name)):'--'}}</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <!-- <div class="calls-table-cell">
                                                <div class="table-td-border-right table-td-border-left o-left-side-padding5 o-right-side-padding5">
                                                    <div class="o-accordion-subtext o-rowtable-text o-notify-cell">
                                                        <span class="">Schedule:</span>
                                                        <div class="notify-icon"><a href="javascript: void(0)" @click="viewSchedule(employee.employee_id)"><i class="fa fa-eye" aria-hidden="true"></i></a></div>
                                                    </div>
                                                </div>
                                            </div>  -->
                                        <div class="calls-table-cell">
                                            <div class="table-td-border-right table-td-border-left o-right-side-padding5 ">
                                                <div class="calls-table-cell-inner-table">
                                                    <div class="o-accordion-subtext o-rowtable-text o-no-padding">
                                                        <span>Client:</span>
                                                        <div>{{ employee.client_employee && employee.client_employee.clients && employee.client_employee.clients.subdomain ? employee.client_employee.clients.subdomain +' ('+employee.client_employee.clients.contact_person+')' : ' -- '}}</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="calls-table-cell">
                                                <div class="o-right-side-padding5 ">
                                                <div class="calls-table-cell-inner-table">
                                                    <!-- <div class="o-accordion-subtext o-rowtable-text o-no-padding">
                                                        <span>Sen:</span>
                                                        <div>{{employee.seniority}}</div>
                                                    </div> -->
                                                </div>
                                            </div>
                                        </div>

                                        <div class="calls-table-cell">
                                            <div class="table-td-border-right o-right-side-padding5">
                                                <div class="o-accordion-subtext o-rowtable-text">
                                                    <span>Email ID:</span>
                                                    <div>{{employee.employable ? employee.employable.email:'--'}}</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="calls-table-cell">
                                            <div class="table-td-border-right o-right-side-padding5">
                                                <div  class="o-accordion-subtext o-rowtable-text">
                                                    <span>Send:</span>
                                                    <div class="notify-icon">
                                                        <a href="javascript: void(0)" class="send-reset-email" @click="sendEmail(employee)">
                                                            Email Reset Link
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="calls-table-cell">
                                            <div class="table-td-border-right o-right-side-padding5">
                                                <div  class="o-accordion-subtext o-rowtable-text">
                                                    <span>Phone:</span>
                                                    <div v-if="employee.employable">
                                                        <div v-for="(phone,phoneIndex) in employee.employable.phones" :key="phoneIndex" 
                                                        v-if="phone.label=='Home phone' || phone.label=='home'">
                                                            <!-- {{ phone.phone_number? phone.phone_number: '' }} -->
                                                            <a :href="'tel:'+getClientContactFormat(phone.phone_number)" class="phone-number-display">
                                                            {{ phone.phone_number ? getClientContactFormat(phone.phone_number) : '' }}
                                                        </a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="calls-table-cell">
                                            <div class="table-td-border-right o-right-side-padding5">
                                                <div class="o-accordion-subtext o-rowtable-text">
                                                    <span>Cell:</span>
                                                    <div v-if="employee.employable">
                                                        <div v-for="(phone,phoneIndex) in employee.employable.phones" :key="phoneIndex" 
                                                        v-if="phone.label=='Cell phone' || phone.label=='mobile' || phone.label=='cell'">
                                                            <!-- {{phone.phone_number? phone.phone_number: '' }} -->
                                                            <a :href="'tel:'+getClientContactFormat(phone.phone_number)" class="phone-number-display">
                                                            {{ phone.phone_number ? getClientContactFormat(phone.phone_number) : '' }}
                                                        </a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="calls-table-cell">
                                            <div class="table-td-border-right o-right-side-padding5">
                                                <div class="o-accordion-subtext o-rowtable-text o-notify-cell">
                                                    <span class="">Send Event</span>
                                                    <div class="notify-icon">
                                                        <a href="javascript: void(0)" class="nylas-event" :class="{'active':getNylasSubscriptionStatus(employee),'inactive':!getNylasSubscriptionStatus(employee)}" @click="sendNylasEvent(employee)">
                                                            <img class="nylas-logo" src="static/assets/images/nylas-logo.svg" />
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="calls-table-cell">
                                            <div class="table-td-border-right o-right-side-padding5">
                                                <div class="o-accordion-subtext o-rowtable-text o-notify-cell">
                                                    <span class="">Notify</span>
                                                    <div class="notify-icon">
                                                        <a href="javascript: void(0)" @click="addBatchNotify(employee)"><i class="fa fa-mobile" aria-hidden="true"></i></a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="calls-table-cell">
                                            <div class="">
                                                <div class="o-accordion-subtext o-rowtable-text o-notify-cell">
                                                    <span class="">View</span>
                                                    <br />
                                                    <a class="notify-icon" :href="goToLogin(employee.id)" target="_blank">
                                                        <i class="fa fa-eye" aria-hidden="true"></i></a>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- <div class="calls-table-cell" v-if="showCustom != 0 && customField1 != null && customField1 != '' && customField1 != 'NULL'">
                                            <div class="table-td-border-left o-left-side-padding5">
                                                <div class="o-accordion-subtext o-rowtable-text">
                                                     <span>
                                                     {{customField1?customField1:''}}
                                                     </span>
                                                     <div>
                                                        <div>
                                                      {{getCustomField(employee.custom_field1).length!=0?getCustomField(employee.custom_field1):'--'}}
                                                        </div>
                                                    </div>
                                                 </div>
                                            </div>
                                        </div>
                                        <div class="calls-table-cell" v-if="showCustom != 0 && customField2 != null && customField2 != '' && customField1 != 'NULL'">
                                            <div class="table-td-border-left o-left-side-padding5">
                                                <div class="o-accordion-subtext o-rowtable-text">
                                                     <span>
                                                     {{customField2}}
                                                     </span>
                                                     <div>
                                                        <div>
                                                      {{getCustomField(employee.custom_field2).length!=0?getCustomField(employee.custom_field2):'--'}}
                                                        </div>
                                                    </div>
                                                 </div>
                                            </div>
                                        </div> -->

                                        <!-- <div class="calls-table-cell text-center o-no-padding">
                                            <div class="o-edit-trash o-no-padding">

                                                <div class="o-table-block-btn">
                                                    <a href="javascript: void(0)"><i class="fa fa-pencil" aria-hidden="true"></i></a>
                                                </div>
                                                <div class="o-table-block-btn">
                                                    <a href="javascript: void(0)"><i class="fa fa-trash-o" aria-hidden="true"></i></a>
                                                </div>

                                            </div>
                                        </div> -->
                                </div>
                            </div>
                          </div>
                        </div>
                    </div>
                </div>
                <div v-if="employees.length==0 && afterApi">
                    <div class="c-common-space c-common-gradient c-common-box-shadow c-radius3">
                        <div class="col-md-12 no-job-dispaly">
                            <i class="fa fa-frown-o" aria-hidden="true"></i>
                            <br />
                            No Data Stored
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
    <!-- /Main Body Content area -->

    <modal name="batch-notify"  height="auto" :scrollable="true" class="modal-dialog modal-sm">
        <div class="modal-add-newJob" tabindex="-1" role="dialog">
            <div  role="document">
                <div class="modal-content o-common-modal-content">
                    <div class="modal-header u-no-border text-center o-small-modal-head">
                        <button @click="closeBatchNotify()" type="button" class="close custom-modal--close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                        <h4 class="modal-title">Notify</h4>
                    </div>
                    <div class="modal-body c-common-box-shadow o-modal-nopad-body">
                        <div class="row">
                            <div class="col-sm-12">
                                <ul class="o-modal-tab">
                                    <li v-if="getNotificationType=='email'"><a href="javascript: void(0)" @click="notifyEmailTab()" :class="(notifyTab == 'email')?'o-tab-active':''">Email</a></li>
                                    <li v-if="getNotificationType=='sms'"><a href="javascript: void(0)" @click="notifySmsTab()" :class="(notifyTab == 'sms')?'o-tab-active':''">SMS</a></li>
                                </ul>
                            </div>
                            <div class="col-sm-12" v-if="notifyTab == 'email'">
                                <div class="form-group o-attachment-sec">
                                    <vue-editor class="" v-model="emailContent"></vue-editor>
                                    <div class="common-label-input--modalwidth o-upload-file attachment-btn-wrapper">
                                        <button class="btn o-attachment-icon"><i class="fa fa-paperclip" aria-hidden="true"></i></button>
                                        <input type="file" name="myfile" @change="attachmentAdded($event)">
                                        <span>{{(attachment)?attachment.name:'No file chosen'}}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-12" v-if="notifyTab == 'sms'">
                                <div class="o-sms-counter o-sms-counter-normal">{{smsContent.length}}/160</div>
                                <textarea maxlength="160" v-model="smsContent" class="form-control o-no-radius notifySms-field" rows="10" placeholder="Type your SMS"></textarea>
                            </div>
                        </div>

                    </div>
                    <div class="modal-footer text-center">
                        <ul class="o-filter-area">
                            <li>
                                <a href="javascript: void(0)" @click="closeBatchNotify()" data-dismiss="modal" aria-label="Close" class="btn c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue"><i class="fa fa-minus-circle" aria-hidden="true"></i> Cancel</a>
                            </li>
                            <li>
                                <a href="javascript: void(0)" @click="sendNotify()" class="btn c-solid-btn c-solid-btn--large c-solid-btn--green"><i class="fa fa-paper-plane" aria-hidden="true"></i> Send</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </modal>

    <modal name="emg-notify"  height="auto" :scrollable="true" class="modal-dialog modal-sm">
             <div class="modal-add-newJob" tabindex="-1" role="dialog">
                <div  role="document">
                    <div class="modal-content o-common-modal-content">
                        <div class="modal-header u-no-border text-center o-small-modal-head">
                            <button @click="closeEmgNotify()" type="button" class="close custom-modal--close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                            <h4 class="modal-title">Emergency Card</h4>
                        </div>
                        <div class="modal-body c-common-box-shadow o-modal-nopad-body">
                            <div class="row">
                                <div class="col-sm-12">
                                Data
                                </div>
                            </div>

                        </div>
                        <div class="modal-footer text-center">
                            <ul class="o-filter-area">
                                <li>
                                    <a href="javascript: void(0)" @click="closeEmgNotify()" data-dismiss="modal" aria-label="Close" class="btn c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue"><i class="fa fa-minus-circle" aria-hidden="true"></i> Cancel</a>
                                </li>
                                
                            </ul>
                        </div>
                    </div>
                </div>
        </div>
    </modal>
  </div>
</template>
<script>
    import { mapGetters } from 'vuex';
    import dateTimeConvert from '../../../timeConvert&Compare.js';
    import { VueEditor } from 'vue2-editor';
    import service from '../../../services.js';
    import { global } from '../../../global.js';

    let timeout = null;
    export default {
        components: {
            VueEditor
        },
        computed: {
            ...mapGetters({
                userToken: 'userToken',
                userRole: 'userRole',
                userID: 'userID',
            }),    
        },
        data() {
            return {   
                loading:true,
                afterApi:false,   
                selectedShortType:'fname_asc',
                search_query:'',
                employees:[], 
                savedEmployees:[],
                last_page:null,
                next_page:null,
                getNotificationType:'email',
                selectedEmpId: [],
                attachment : null,
                emailContent: '',
                smsContent: '',
                client_id: '',
                role_id: ''
            }
        },
        beforeMount() {
            this.getAllEmployee();
        },
        methods: {
            getClientContactFormat(phone) {
                phone = phone ? phone.toString() : '';
                // phone = phone.replace(/-/g, "");
                // phone = phone.replace(/ /g, "");
                // phone = phone.replace("(", "");
                // phone = phone.replace(")", "");
                let result = '';
                if(phone&&phone.length==10) { 
                    // console.log(phone);
                    result = '+1'+phone;
                }else if(phone&&phone.length==11) {
                    // console.log(phone);
                    result = '+' + phone;
                }else if(phone&&phone.length) {
                    result = phone;
                }
                return result;
                // return phone;
            },
            getNylasSubscriptionStatus(emp) { 
                let status = false;
                if(emp.employable.nylas_subscription&&emp.employable.stripe_subscription) {
                    status = true;
                }
                return status;
            },
            goToMerge(){
                this.$router.push({
                    'path': '/mergeEmployee'
                });
            },
            goToLogin(employeeId) {
                let url="http://login." +global[0].CLIENT_BASE+"#/login/employee/"+btoa(employeeId)+"/"+btoa(this.userToken);
                return url;

                // this.$Progress.start();
                // service.get('employee_universal_login', {
                //     'Authorization': this.userToken,
                //     'employeeid': employeeId,
                //     'url': "http://login." + global[0].CLIENT_BASE,
                // })
                // .then((res) => {
                //     console.log(res);
                //     if (res.data.status_message != "Login successful") {
                //         this.$Progress.fail();
                //         this.$router.push({
                //             path: "/login"
                //         });
                //     } else {
                //         console.log('correct');
                //         this.$store.dispatch('userSession', res);
                //         this.$cookies.set("csLogin", res.data.role.slug, "23h");
                //         this.$cookies.set("date_format", res.data.user.employees[0].date_format, "23h");
                //         this.$cookies.set("time_format", res.data.user.employees[0].time_format, "23h");
                //         this.$Progress.finish();
                //         if (res.data.role.slug != "super-admin") {
                //             this.$cookies.set("time_zone", res.data.user.employees[0].client[0].clients.timezone, "23h");
                //             var notifyType = (res.data.user.employees[0].email_notification == 1) ? 'email' : 'sms';
                //             this.$store.dispatch('setNotificationType', notifyType);
                //             this.$store.dispatch('setClientdata', res.data.user.employees[0].client[0].clients);
                //             location.reload(true);
                //             // window.location.replace(window.location.href.split('#')[0]);
                //             // if (res.data.role.slug == "client-admin" || res.data.role.slug == "power-user" && res.data.user.employees[0].client.length>0) {
                //             //     this.$router.push({
                //             //         path: "/jobList"
                //             //     });
                //             // } else {
                //             //     this.$router.push({
                //             //         path: "/schedule/"+btoa(this.employeeId),
                //             //     });
                //             // }

                //         } else {
                //             // location.reload(true);
                //             this.$router.push({
                //                 path: "/clientList"
                //             });
                //         }

                //     }
                //         //window.location.href = "http://" + subdomain + "." + global[0].CLIENT_BASE;
                // }).catch((err) => {
                //     console.log(err);
                //     this.$router.push({
                //         path: "/login"
                //     });
                // });
                //return "http://" + subdomain + "." + global[0].CLIENT_BASE;
            },   
            // goToLogin(employee){
            //     // console.log(employee);
            //     // let url="https://login."+global[0].CLIENT_BASE+"#/login/"+btoa(employee.employable_id)+"/"+btoa(this.userToken);
            //     // // return(window.location.href.split('#')[0]+"#/login/"+clientId+"/"+this.userToken);
            //     // return url;

            //     return 'https://login.dev-callsteward.com'
            // },

            attachmentAdded($event)
            {
              if($event.target.files.length != 0)
                this.attachment = $event.target.files[0];
              else
                 this.attachment = null;
              //console.log(this.attachment.name);
            },

            updateValue(){
                clearTimeout(timeout);
                timeout = setTimeout(() => {
                    this.getAllEmployee();
                }, 1000);
            },
            viewSchedule(empId){
                this.$router.push({
                    'path': '/schedule/'+btoa(empId)
                });
            },
            getPower(data) {
                //console.log('headernav',typeof dateTimeConvert.checkAccess(data));
                return dateTimeConvert.checkAccess(data);
            },
            // getCustomField(data) {
            //     var customFld = JSON.parse(data);
            //     return customFld.value;          
            // },

            sendEmail(emp) {
                console.log(emp);
                let redirect_link = 'https://login.'+global[0].CLIENT_BASE+'#/resetPassword';
                service.post('auth/forgotPassword', {
                    redirect_link: redirect_link,
                    email: emp.employable.email,
                }, {}).then((res) => {
                    if (res.data.result.status == 0) {
                        this.$notify({
                            title: this.$t('error'),
                            message: res.data.result.message,
                            type: 'error'
                        });
                        //console.log('incorrect');
                    } else {
                       // console.log('correct');
                        this.$notify({
                            title: this.$t('success'),
                            message: this.$t('reset_password_link_sent'),
                            type: 'success'
                        });
                    }

                }).catch((err) => {
                    this.$notify({
                        title: this.$t('error'),
                        message: this.$t('invalid_login_credentials'),
                        type: 'error'
                    });
                });
            },

            sendNotify() {
                var formData;
                //let formData = {};
                if (this.notifyTab == 'email') {
                    formData = new FormData();
                    formData.append('email', this.emailContent);
                    formData.append('client_id', this.client_id);
                    formData.append('employee_ids', JSON.stringify(this.selectedEmpId));
                    if(this.attachment != null || this.attachment == "")
                    {
                      formData.append("attachment", this.attachment);
                    }
                    /*formData = {
                        email: this.emailContent,
                        client_id: this.userClientID,
                        employee_ids: JSON.stringify(this.selectedEmpId)
                    };*/
                    //console.log(formData);
                } else {
                    formData = {
                        sms: this.smsContent,
                        client_id:  this.client_id,
                        employee_ids: JSON.stringify(this.selectedEmpId)
                    };
                    //console.log(formData);
                }
                // console.log(this.userID);
                service.post('employee/notifyEmployee', formData, {
                        'Authorization': this.userToken,
                        'cs3-context-role': this.userRole,
                        'cs3-context-clientId': this.client_id,
                        'user-id': this.userID
                    })
                    .then((res) => {
                        this.$notify({
                            title: this.$t('success'),
                            message: 'Notify Successfully.',
                            type: 'success'
                        });
                        this.$modal.hide('batch-notify');
                    }).catch((err) => {
                        console.log(err);

                    });
            },

            sendNylasEvent(emp) {
                if(emp.employable.stripe_subscription&&emp.employable.nylas_subscription) {
                    console.log('Nylas Event');
                    service.post('employee/sendNylasTestEvent', { employee_id: emp.id }, {
                        'Authorization': this.userToken
                    })
                    .then((res) => {
                        console.log(res.data);
                        if(res.data.status_code == "1") {
                            this.$notify({
                                title: 'Success',
                                message:res.data.status_message + ' for ' + res.data.result.email_address,
                                type: 'success'
                            });
                        }else {
                            this.$notify({
                                title: 'Error',
                                message:res.data.status_message,
                                type: 'error'
                            });
                        }
                    }).catch((err) => {
                        console.log(err);
                        this.$notify.error({
                        title: 'Error!',
                        message: 'Something went wrong'
                    });

                    });
                }else if(!emp.employable.stripe_subscription&&!emp.employable.nylas_subscription){
                    this.$notify.error({
                        title: 'Error!',
                        message: 'Missing Both Nylas and Stripe Subscriptions'
                    });
                }else if(!emp.employable.nylas_subscription) {
                    this.$notify.error({
                        title: 'Error!',
                        message: 'Missing only Nylas Subscription'
                    });
                }else {
                    this.$notify.error({
                        title: 'Error!',
                        message: 'Missing only Stripe Subscription'
                    });
                }
            },            

            notifyEmailTab() {
                this.notifyTab = 'email';
            },

            notifySmsTab() {
                this.notifyTab = 'sms';
            },

            addBatchNotify(emp) {
                console.log(emp);
                this.selectedEmpId = [];
                this.getNotificationType=emp.email_notification==1?'email':'sms';
                if(emp.email_notification==1){
                    this.getNotificationType='email';
                    this.notifyTab = 'email';
                }else{
                    this.getNotificationType='sms';
                    this.notifyTab = 'sms';
                }
                this.selectedEmpId.push(emp.id);
                this.client_id = emp.client_employee.client_id
                this.role_id = emp.employable.role_id
                //console.log(employeeId);
                this.emailContent = "";
                this.smsContent = "";
                this.$modal.show('batch-notify');
            },
            closeBatchNotify() {
                this.$modal.hide('batch-notify');
            },
            // addEmgNotify() {
            //     this.$modal.show('emg-notify');
            // },
            // closeEmgNotify() {
            //     this.$modal.hide('emg-notify');
            // },
            // deleteEmployees(id) {
            //     this.$confirm('NAME will be removed from the records of CLIENT. Continue?', 'Warning', {
            //         confirmButtonText: 'OK',
            //         cancelButtonText: 'Cancel',
            //         type: 'warning'
            //     }).then(() => {
            //         service.del('employee/' + id, {
            //             'Authorization': this.userToken,
            //             'cs3-context-role': this.userRole,
            //             'cs3-context-clientId': this.userClientID
            //         }).
            //         then((res) => {
            //             this.getAllEmployee();
            //             this.$message({
            //                 type: 'success',
            //                 message: 'Delete completed'
            //             });
            //         }).catch((err) => {
            //             console.log(err);
            //         });
            //     }).catch(() => {
            //         this.$message({
            //             type: 'info',
            //             message: 'Delete canceled'
            //         });
            //     });
            // },

            getAllEmployee() {
                this.$Progress.start();
                this.loading = true;
                this.afterApi = false;
                this.employees=[];
                this.savedEmployees =[];
                service.get('employee/getEmployees', {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'status': 'all',
                    'sort': this.selectedShortType,
                    'search': this.search_query,
                }).then((res) => {
                    this.employees = res.data.result.data;
                    //console.log("fffff", this.employees);
                    this.$Progress.finish();
                    this.last_page = res.data.result.total;
                    this.next_page = res.data.result.next_page_url;
                    this.loading = false;
                    this.afterApi = true;
                    //console.log("res", res.data.result.data[0].employable);
                    //this.sortEmployee();
                    if (this.next_page != null || this.next_page != "") {
                        service.getUrl(this.next_page, {
                            'Authorization': this.userToken,
                            'cs3-context-role': this.userRole,
                            'status': 'all',
                            'sort': this.selectedShortType,
                            'search': this.search_query,
                        }).then((res) => {
                            this.savedEmployees = res.data.result.data;
                            this.next_page = res.data.result.next_page_url;

                        }).catch((err) => {
                            console.log(err);
                        });
                    } 
                }).catch((err) => {
                    console.log(err);
                    this.loading = false;
                    this.afterApi = true;
                });
            },
            loadMore() {
                var arr = this.employees;
                if (this.savedEmployees.length != 0) {
                    this.savedEmployees.forEach(function(entry) {
                        arr.push(entry);
                    })
                    this.savedEmployees=[];
                    if (this.next_page != null || this.next_page != "") {
                        service.getUrl(this.next_page, {
                            'Authorization': this.userToken,
                            'cs3-context-role': this.userRole,
                            'status': 'all',
                            'sort': this.selectedShortType,
                            'search': this.search_query,
                        }).then((res) => {
                            this.savedEmployees = res.data.result.data;
                            this.page_no += 1;
                            this.next_page = res.data.result.next_page_url;

                        }).catch((err) => {
                            console.log(err);
                        });
                    }
                } else
                    this.savedEmployees = [];

            },
            // addEmployee() {
            //     this.$router.push({
            //         'path': '/addEmployee'
            //     });
            // },
            // deleteEmployee() {
            //     this.$router.push({
            //         'path': '/deleteEmployee'
            //     });
            // },
            // editEmployee(employee) {
            //     this.$store.dispatch('selectEmployee', {
            //         'id': employee.employee_id,
            //         'name': employee.employable.first_name + ' ' + employee.employable.last_name,
            //         'type': employee.employable_type
            //     });
            //     this.$store.dispatch('setEditEmployeesFrom', 'editEmployeeList');
            //     // this.$store.dispatch('selectEmployee', {
            //     //     'id': employee.id,
            //     //     'name': employee.employable.first_name + ' ' + employee.employable.last_name,
            //     //     'type': employee.employable_type
            //     // });
            //     this.$router.push({
            //         'path': '/editEmployee/'+btoa(employee.employee_id)
            //     });
            // },

            // getData() {
            //     return "<p>Hello</p>";
            // },
            
            // goToEmployeeDetails(employee) {
            //     this.$store.dispatch('selectEmployee', {
            //         'id': employee.employee_id,
            //         'name': employee.employable.first_name + ' ' + employee.employable.last_name,
            //         'type': employee.employable_type
            //     });
            //     this.$router.push({
            //         path: '/employeeDetails/' + btoa(employee.employee_id)
            //     });
            // },

            // getPhone(phone) {
            //     if (phone.length == 0)
            //         return phone.length;
            //     else
            //         return phone[0].phone_number;
            // },
            // getClient(){
            //     service.get('client/' + this.userClientID, {
            //         'Authorization': this.userToken
            //     }).
            //     then((res) => {
            //         //this.turnoverTime=res.data.result.turnover;

            //         this.customField1 = res.data.result.custom_field_1;
            //         this.customField2 = res.data.result.custom_field_2;
            //         this.showCustom = res.data.result.employee_title;
            //         this.selectedShortType=res.data.result.default_employee_sort;
            //         this.getAllEmployee();
            //     }).catch((err) => {
            //         console.log(err);
            //     });        
            // }
        },
        
        created() {
            
            this.notifyTab = this.getNotificationType;
        }

    }

</script>
<style scoped>
    .phone-number-display{
        padding: 5px;
        cursor: pointer;
        color: #222222;
        text-decoration: none !important;
    }

    /* o-calls-table .calls-table-row .o-accordion-subtext a {
        text-decoration: underline;
        color: #222;
    } */
    .employees-list-table-align .calls-table-row .calls-table-cell:nth-child(3) {
        width: 10px!important;
    }
    .send-reset-email {
        color: #006bbd;
        text-decoration: none!important;
    }

    .send-reset-email:hover {
        color: #006bbd!important;
    }

    .nylas-logo {
        height: 25px;
        width: 60px;
        padding: 8px 5px 0;
    }
    .nylas-event {
        font-size: 14px;        
        border-radius: 5px;
        text-decoration: none!important;
        padding: 8px 8px 0;
        /* color: #8158b8!important;        
        border: 1px solid #8158b8; */
    }
    .nylas-event.active {       
        background-color: #8158b8!important;        
        border: 1px solid #8158b8;
    }
    .nylas-event.active:hover {       
        color: #8158b8!important;        
        border: 1px solid #8158b8;
    }

    .nylas-event.inactive {       
        background-color: #da4e4e!important;        
        border: 1px solid #da4e4e;
    }

    .nylas-event.inactive:hover {       
        color: #da4e4e!important;        
        border: 1px solid #da4e4e;
    }

    .employees-list-table-align .calls-table-row .calls-table-cell:first-child {
        width: 250px;
        text-align: center;
        padding-left: 10px;
    }
    .employees-list-table-align .calls-table-row .calls-table-cell:nth-child(2) {
        text-align: left;
        width: 201px;
    }
    .pointHere {
        cursor: pointer;
    }

    .tooltip {
        display: block !important;
        z-index: 10000;
    }

    .tooltip .tooltip-inner {
        background: #f9ffb5;
        color: black;
        border-radius: 16px;
        padding: 5px 10px 4px;
    }

    .tooltip .tooltip-arrow {
        width: 0;
        height: 0;
        border-style: solid;
        position: absolute;
        margin: 5px;
        border-color: #f9ffb5;
    }

    .tooltip[x-placement^="top"] {
        margin-bottom: 5px;
    }

    .tooltip[x-placement^="top"] .tooltip-arrow {
        border-width: 5px 5px 0 5px;
        border-left-color: transparent !important;
        border-right-color: transparent !important;
        border-bottom-color: transparent !important;
        bottom: -5px;
        left: calc(50% - 5px);
        margin-top: 0;
        margin-bottom: 0;
    }

    .tooltip[x-placement^="bottom"] {
        margin-top: 5px;
    }

    .tooltip[x-placement^="bottom"] .tooltip-arrow {
        border-width: 0 5px 5px 5px;
        border-left-color: transparent !important;
        border-right-color: transparent !important;
        border-top-color: transparent !important;
        top: -5px;
        left: calc(50% - 5px);
        margin-top: 0;
        margin-bottom: 0;
    }

    .tooltip[x-placement^="right"] {
        margin-left: 5px;
    }

    .tooltip[x-placement^="right"] .tooltip-arrow {
        border-width: 5px 5px 5px 0;
        border-left-color: transparent !important;
        border-top-color: transparent !important;
        border-bottom-color: transparent !important;
        left: -5px;
        top: calc(50% - 5px);
        margin-left: 0;
        margin-right: 0;
    }

    .tooltip[x-placement^="left"] {
        margin-right: 5px;
    }

    .tooltip[x-placement^="left"] .tooltip-arrow {
        border-width: 5px 0 5px 5px;
        border-top-color: transparent !important;
        border-right-color: transparent !important;
        border-bottom-color: transparent !important;
        right: -5px;
        top: calc(50% - 5px);
        margin-left: 0;
        margin-right: 0;
    }

    .tooltip[aria-hidden='true'] {
        visibility: hidden;
        opacity: 0;
        transition: opacity .15s, visibility .15s;
    }

    .tooltip[aria-hidden='false'] {
        visibility: visible;
        opacity: 1;
        transition: opacity .15s;
    }

</style>



// WEBPACK FOOTER //
// src/components/superAdmin/employees/superAdminEmployeeList.vue